export const PRODUCTS_DATA_KEY = 'productsData';
export const GEOLOCATION_DATA_KEY = 'geolocationData';
